module.exports = __webpack_public_path__ + "img/logo_incellderm_typo.de898918.svg";